<template>
  <div>
    <transition-group
      name="sidebar-transition"
      tag="div"
      @after-enter="onAfterEnter"
      @after-leave="onAfterLeave"
      @before-enter="onBeforeEnter"
      @before-leave="onBeforeLeave"
    >
      <template v-for="sidebar in visibleSidebars">
        <InstanceDetails
          v-if="sidebar.type == 'details'"
          :key="sidebar.id"
          :sidebar="sidebar"
          :uuid="sidebar.uuid"
        />
        <StoreyPreview
          v-if="sidebar.type == 'preview'"
          :key="sidebar.id"
          :sidebar="sidebar"
          :uuid="sidebar.uuid"
        />
        <InstanceGroupPreview
          v-if="sidebar.type == 'group'"
          :key="sidebar.id"
          :sidebar="sidebar"
          :uuid="sidebar.uuid"
        />
        <VuebergInfo
          v-if="sidebar.type == 'info'"
          :key="sidebar.id"
          :sidebar="sidebar"
          :uuid="sidebar.uuid"
        />
      </template>
    </transition-group>
    <ImageModal
      v-if="sidebarModal && sidebarModal.type == 'image'"
      :modal="sidebarModal"
    />
    <VideoModal
      v-if="sidebarModal && sidebarModal.type == 'video'"
      :modal="sidebarModal"
    />
    <IframeModal
      v-if="sidebarModal && sidebarModal.type == 'iframe'"
      :modal="sidebarModal"
    />
    <ConstructionStageModal
      v-if="sidebarModal && sidebarModal.type == 'image-construction'"
      :modal="sidebarModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ImageModal from './modals/ImageModal.vue';
import IframeModal from './modals/IframeModal.vue';
import VideoModal from './modals/VideoModal.vue';
import ConstructionStageModal from '@/components/sidebar/modals/ConstructionStageModal';
import InstanceDetails from '@/components/sidebar/templates/details/InstanceDetails.vue';
import StoreyPreview from '@/components/sidebar/templates/preview/StoreyPreview';
import InstanceGroupPreview from '@/components/sidebar/templates/group/InstanceGroupPreview';
import VuebergInfo from '@/components/sidebar/templates/info/VuebergInfo';
export default {
  components: {
    StoreyPreview,
    ConstructionStageModal,
    InstanceGroupPreview,
    InstanceDetails,
    ImageModal,
    VideoModal,
    IframeModal,
    VuebergInfo,
  },

  computed: {
    ...mapGetters([
      'allSidebars',
      'visibleSidebars',
      'sidebarModal',
      'lastSidebar',
      'sidebarTypes',
    ]),
  },

  watch: {
    $route: {
      handler() {
        const { sidebarType, isSidebar } = this.$route.meta;
        const { sidebarContext, sidebarSubcontext } = this.$route.params;

        if (
          isSidebar &&
          (this.lastSidebar?.route != sidebarType ||
            this.lastSidebar?.context != sidebarContext ||
            this.lastSidebar?.subcontext != sidebarSubcontext)
        ) {
          this.OPEN_SIDEBAR({
            route: sidebarType,
            size: 1,
            context: sidebarContext,
            subcontext: sidebarSubcontext,
            payload: {},
            isSingleton: true,
            persist: false,
          });
          this.updateSidebarClasses(this.visibleSidebars);
        }
      },
      immediate: true,
    },
  },
  mounted() {},

  created() {
    this.updateSidebarClasses(this.visibleSidebars);

    window.eventBus.$on('sidebar:update', () => {
      this.updateSidebarClasses(this.visibleSidebars);
    });
  },
  methods: {
    ...mapActions(['OPEN_SIDEBAR']),

    isSidebarVisible(sidebar) {
      return this.visibleSidebars.includes(sidebar);
    },
    onBeforeEnter(el) {
      // console.log("before enter  Manager");
      window.eventBus.$emit('sidebar:beforeEnter');

      if (this.$route.meta.handleEnterSidebarClassImmediately === true) {
        this.updateSidebarClasses(this.visibleSidebars);
      }
    },
    onAfterEnter(el) {
      // console.log("after enter  Manager");
      window.eventBus.$emit('sidebar:afterEnter');

      if (this.$route.meta.handleEnterSidebarClassImmediately !== true) {
        this.updateSidebarClasses(this.visibleSidebars);
      }
    },

    onBeforeLeave(el) {
      console.log('before Leave Manager');
      window.eventBus.$emit('sidebar:beforeLeave', this.visibleSidebars);

      if (this.$route.meta.handleLeaveSidebarClassImmediately === true) {
        this.updateSidebarClasses(this.visibleSidebars);
      }
    },
    onAfterLeave(el) {
      // console.log("after Leave Manager");
      window.eventBus.$emit('sidebar:afterLeave');

      if (this.$route.meta.handleLeaveSidebarClassImmediately !== true) {
        this.updateSidebarClasses(this.visibleSidebars);
      }
    },

    updateSidebarClasses(sidebars) {
      // console.log("before enter");

      document.body.classList.remove('body-sidebar-opened');
      [
        'body-sidebar-size-1',
        'body-sidebar-size-1-1',
        'body-sidebar-size-1-2',
        'body-sidebar-size-1-3',
        'body-sidebar-size-2',
        'body-sidebar-size-2-2',
        'body-sidebar-size-2-3',
        'body-sidebar-size-3',
        'body-sidebar-size-3-3',
      ].forEach((className) => document.body.classList.remove(className));

      const sizes = sidebars.map((sidebar) => sidebar.size);
      // console.log(sizes);
      if (sizes.length == 0) {
        return;
      }
      document.body.classList.add(`body-sidebar-opened`);

      if (sizes.length === 1) {
        document.body.classList.add(`body-sidebar-size-${sizes[0]}`);
      } else if (sizes.length >= 2) {
        const [size1, size2] = sizes.slice(0, 2).sort((a, b) => a - b);
        document.body.classList.add(`body-sidebar-size-${size1}-${size2}`);
      }
    },
  },
};
</script>
<style lang="scss">
@import '/src/assets/styles/sidebar.scss';
</style>
